import { useEffect, useState } from 'react';
import Aos from 'aos';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Hero from './components/UI/Hero';
import Products from './components/UI/Products';
import Contact from './components/UI/Contact';
import Error from './components/UI/Error'; // Replace './Loader' with the actual path to your Loader component
import Loader from './components/Loader/Loader';
import Aboutus from './components/UI/Aboutus';
import Technology from './components/UI/Technology';
import Uses from './components/UI/Uses';

// import AnimatedCursor from "react-animated-cursor"

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Aos.init();

    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  return (
    <Router>
      <div>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Header />
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route path="/aboutus" element={<Aboutus />} />
              <Route path="/products" element={<Products />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/uses" element={<Uses />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Error />} />
            </Routes>
            <Footer />
          </>
        )}
      </div>
    </Router>
  );
}

export default App;
